export const agenda = {
  today: 'Azi',
  tomorrow: 'Mâine',
  dayAfterTomorrow: 'Poimâine',

  inIntervalLabel: 'În intervalul',

  fromPlaceholder: 'de la',
  toPlaceholder: 'până la',

  eventsInFuture: 'Evenimente în viitor',
  inNDays: 'într-o zi | în {n} zile'
}
